import { render } from "./ProviderSync.vue?vue&type=template&id=7a73d8f0&scoped=true"
import script from "./ProviderSync.vue?vue&type=script&lang=js"
export * from "./ProviderSync.vue?vue&type=script&lang=js"

import "./ProviderSync.vue?vue&type=style&index=0&id=7a73d8f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a73d8f0"]])

export default __exports__